<div class="hmf-text-align-left seo-bar hmf-pt-0 hmf-px-m">
	<hmf-breadcrumbs
		(notifyRouter)="navigateToRoute($event)"
		[breadcrumbs]="breadcrumbs"
		[currentPageIncluded]="true"
		[routerPresent]="true"
		[ngClass]="{'non-clickable': !isBreadcrumbClickable}">
	>
	</hmf-breadcrumbs>
	<hmf-divider class="seo-bar hmf-mb-m-m hmf-my-s" variant="default"></hmf-divider>
</div>
